import { history } from 'instantsearch.js/es/lib/routers'

export default function (indexName) {
  return {
    router: history({
      windowTitle({ query }) {
        const queryTitle = query ? `"${query}"` : 'Search'
        return queryTitle + ' - Utilites Disputes Limited'
      },

      createURL({ qsModule, routeState, location }) {
        const urlParts = location.href.match(/^(.*?)\/search/)
        const baseUrl = `${urlParts ? urlParts[1] : ''}/`

        const queryParameters = {}

        if (routeState.query) {
          queryParameters.query = encodeURIComponent(routeState.query)
        }
        if (routeState.page !== 1) {
          queryParameters.page = routeState.page
        }

        const queryString = qsModule.stringify(queryParameters, {
          addQueryPrefix: true,
          arrayFormat: 'repeat',
        })

        return `${baseUrl}search${queryString}`
      },

      parseURL({ qsModule, location }) {
        const { query = '', page } = qsModule.parse(location.search.slice(1))
        return {
          query: decodeURIComponent(query),
          page,
        }
      },
    }),

    stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState[indexName] || {}

        return {
          query: indexUiState.query,
          page: indexUiState.page,
        }
      },

      routeToState(routeState) {
        const state = {
          query: routeState.query,
          page: routeState.page,
        }

        return {
          [indexName]: state,
        }
      },
    },
  }
}
